import { reducers } from "components/administration/designManager/themeSlice";
import { createSlice } from "@reduxjs/toolkit";

const channelThemeSlice = createSlice({
  name: "channelTheme",
  initialState: {},
  reducers: {
    ...reducers({ override: true }),
    resetTheme() {
      return {};
    },
  },
});

export const {
  setTheme,
  resetTheme,
  setBannerImage,
  setLogoImage,
  changeColor,
  setHeaderVariant,
} = channelThemeSlice.actions;
export default channelThemeSlice.reducer;
